import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { generateReturnDetailsUrl } from '../../../store/returns/details/returns.details.helpers';
import {
  getPreviousAndNextFulfillmentIdsFromReturnsGrid,
  useIsEnhancedReturnsFeatureEnabled,
} from '../../../store/returns/returns.helpers';
import Global from '../../../store/global-selectors';
import asModal from '../../../components/as-modal';

import { ReturnDetailsModal } from './index';

const ReturnDetailsModalContainerComponent = ({
  loadDetails,
  setSelectedReturns,
  onClose,
  modalProperties: { modalId },
  fulfillmentId,
  returnDetailModalId,
}) => {
  const isEnhancedReturnsFeatureEnabled = useIsEnhancedReturnsFeatureEnabled();
  const updateSelectedGridRecord = useSelector((state) => {
    const fulfillmentIds = Global.selectReturnsGridReturns(state).map((record) => record.fulfillmentId);
    return fulfillmentIds.indexOf(fulfillmentId) !== -1;
  });
  const { nextFulfillmentId, previousFulfillmentId } = useSelector((state) =>
    getPreviousAndNextFulfillmentIdsFromReturnsGrid(state, fulfillmentId, isEnhancedReturnsFeatureEnabled),
  );

  const nextReturnDetailsUrl = nextFulfillmentId ? generateReturnDetailsUrl(nextFulfillmentId) : undefined;
  const previousReturnDetailsUrl = previousFulfillmentId ? generateReturnDetailsUrl(previousFulfillmentId) : undefined;

  useEffect(() => {
    if (updateSelectedGridRecord) {
      setSelectedReturns([fulfillmentId]);
    }
  }, [fulfillmentId, setSelectedReturns, updateSelectedGridRecord]);

  useEffect(() => {
    if (fulfillmentId) {
      loadDetails(fulfillmentId, modalId, returnDetailModalId);
    }
  }, [fulfillmentId, loadDetails, modalId, returnDetailModalId]);

  return (
    <ReturnDetailsModal
      fulfillmentId={fulfillmentId}
      nextReturnDetailsUrl={nextReturnDetailsUrl}
      onClose={onClose}
      previousReturnDetailsUrl={previousReturnDetailsUrl}
      returnDetailModalId={returnDetailModalId}
    />
  );
};

ReturnDetailsModalContainerComponent.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
  loadDetails: PropTypes.func.isRequired,
  modalProperties: PropTypes.shape({
    modalId: PropTypes.string,
  }).isRequired,
  returnDetailModalId: PropTypes.string.isRequired,
  setSelectedReturns: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export const ReturnDetailsModalContainer = asModal(ReturnDetailsModalContainerComponent);
